interface ClearFiltersButtonProps {
  disabled: boolean
  onClear: () => void
}

export function ClearFiltersButton({ disabled, onClear }: ClearFiltersButtonProps) {
  return (
    <div
      className={`border border-[#d9d9d9] bg-white px-4 h-[32px] flex items-center justify-center text-sm text-gray-500 cursor-pointer ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      }`}
      onClick={disabled ? undefined : onClear}
      style={{ lineHeight: '32px', minWidth: '100px' }}
    >
      Clear Filters
    </div>
  )
}
